import LicenseProto from "./license-proto";
import {License} from "../const/license";

export default class LicenseTrial extends LicenseProto {

    public trialPeriod  : any

    constructor(license:License,trialPeriod:any) {
        super(license);

        this.trialPeriod    = trialPeriod;
        this.isTrial        = true;

        this.name = (trialPeriod===0)?'Trial / Business / Unlimited':'Trial / Business / '+this.trialPeriod+' days';

        this.maxStorage     = 'Unlimited';

        this.isPro          = true;
        this.isPaid         = false;

    }


}
